import auth from "./Purchaser/Auth.ts";
import awards from "./Purchaser/Awards.ts";
import billing from "./Purchaser/Billing.ts";
import dashboard from "./Purchaser/Dashboard.ts";
import compare from "./Purchaser/Compare";
import connectEmail from "./Purchaser/ConnectEmail.ts";
import fileUpload from "./Purchaser/FileUpload.ts";
import labels from "./Purchaser/Labels.ts";
import notifications from "./Purchaser/Notifications.ts";
import products from "./Purchaser/Products.ts";
import rejections from "./Purchaser/Rejections.ts";
import reminders from "./Purchaser/RFQReminders.ts";
import rfq from "./Purchaser/RFQ.ts";
import rfqAttributes from "./Purchaser/RFQAttributes.ts";
import rfqSubscriptions from "./Purchaser/RFQSubscriptions.ts";
import team from "./Purchaser/Team.ts";
import templates from "./Purchaser/RFQTemplates.ts";
import vendorDiscovery from "./Purchaser/VendorDiscovery.ts";
import vendorRelationship from "./Purchaser/VendorRelationship.ts";
import vendorImport from "./Purchaser/VendorImport";
import unsubscribe from "./Purchaser/Unsubscribe.ts";
import lists from "./Purchaser/Lists.ts";
import events from "./Purchaser/Events.ts";
import webhookEndpoints from "./Purchaser/WebhookEndpoints.ts";
import emailActivity from "./Purchaser/EmailActivity.ts";
import outreach from "./Purchaser/Outreach.ts";
import productCatalog from "./Purchaser/ProductCatalog.ts";
import mailbox from "./Purchaser/RFQMailbox.ts";
import sourcingRequests from "./Purchaser/SourcingRequests.ts";
import purchaseOrders from "./Purchaser/PurchaseOrders.ts";

export default {
    ...auth,
    ...awards,
    ...billing,
    ...dashboard,
    ...compare,
    ...connectEmail,
    ...fileUpload,
    ...labels,
    ...notifications,
    ...products,
    ...rejections,
    ...reminders,
    ...rfq,
    ...rfqAttributes,
    ...rfqSubscriptions,
    ...team,
    ...templates,
    ...vendorDiscovery,
    ...vendorRelationship,
    ...vendorImport,
    ...unsubscribe,
    ...lists,
    ...events,
    ...webhookEndpoints,
    ...mailbox,
    ...emailActivity,
    ...outreach,
    ...productCatalog,
    ...sourcingRequests,
    ...purchaseOrders,
};
